// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-loader-container {
  justify-content: center;
  width: 100vw;
  display: flex;
  align-items: center;
  height: 100vh;
  flex-direction: column;
  opacity: 1;
  scroll-behavior: smooth;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(41, 28, 28, 0.9);
  z-index: 20000;
}

.global-loader-message {
  color: var(--primaryColorLight);
  font-weight: 600;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/common/global-loader/global-loader.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".global-loader-container {\n  justify-content: center;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  height: 100vh;\n  flex-direction: column;\n  opacity: 1;\n  scroll-behavior: smooth;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background: rgba(41, 28, 28, 0.9);\n  z-index: 20000;\n}\n\n.global-loader-message {\n  color: var(--primaryColorLight);\n  font-weight: 600;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
